<script setup lang="ts">
import NewHeader from '~/components/NewHeader.vue';
import NewFooter from '~/components/NewFooter.vue';
import FaceSwap from '@/components/FaceSwap.vue';
import type { MaterialWithStatus } from '~/types';
import { useDisplay } from 'vuetify';

const { t } = useI18n();

useHead({
    title: t('seo.faceSwap.title'),
    meta: [
        {
            name: 'description',
            content: t('seo.faceSwap.description')
        }
    ]
});

const router = useRouter();
const isShow = ref(true);

const route = useRoute();

const matObj = useState<MaterialWithStatus>('matObj');

const display = useDisplay();
const isMobile = computed(() => display.xs.value);
</script>

<template>
    <div class="flex flex-col w-full h-screen md:h-auto lg:min-h-screen">
        <NewHeader />
        <div class="container-wrap  mt-[68px] md:mt-[90px] !flex-1 flex flex-col items-center justify-center">
            <div class="inner max-w-[1280px] w-full md:px-8 px-4  flex flex-col items-center mt-6 md:mt-0">
                <h1 v-if="isShow"
                    class="px-2 my-4 text-base font-semibold leading-normal text-center text-white md:text-xl lg:text-3xl">
                    {{ t('pages.faceSwap.title') }}
                </h1>
                <FaceSwap @file-selected="(fileSelected) => isShow = !fileSelected" :mat-obj="matObj">
                </FaceSwap>
               

                <template v-if="isShow">
                    <h2 class="hidden text-xl font-semibold leading-7 text-center text-white md:contents">
                        {{ t('pages.faceSwap.howToTitle') }}
                    </h2>
                    <div
                        class="inline-flex gap-3 justify-around items-center py-2 my-4 w-full rounded-xl bg-neutral-900 md:py-4">
                        <div class="inline-flex flex-col gap-1.5 justify-start items-center rounded-xl">
                            <div class="relative w-10 h-10 md:w-14 md:h-14">
                                <img src="/icon/feature_02.svg" alt="">
                            </div>
                            <div class="self-stretch text-xs font-normal text-center text-white/50 md:text-base">
                                <h3 class="hidden md:contents text-neutral-50">{{ t('pages.faceSwap.step1Label') }}:</h3>
                                <h3>{{ t('pages.faceSwap.step1') }}</h3>
                            </div>
                        </div>
                        <div class="inline-flex flex-col gap-1.5 justify-start items-center rounded-xl">
                            <div class="relative w-10 h-10 md:w-14 md:h-14">
                                <img src="/icon/feature_01.svg" alt="">
                            </div>
                            <div class="self-stretch text-xs font-normal text-center text-white/50 md:text-base">
                                <h3 class="hidden md:contents text-neutral-50">{{ t('pages.faceSwap.step2Label') }}:</h3>
                                <h3>{{ t('pages.faceSwap.step2') }}</h3>
                            </div>
                        </div>
                        <div class="inline-flex flex-col gap-1.5 justify-start items-center rounded-xl">
                            <div class="relative w-10 h-10 md:w-14 md:h-14">
                                <img src="/icon/feature_04.svg" alt="">
                            </div>
                            <div class="self-stretch text-xs font-normal text-center text-white/50 md:text-base">
                                <h3 class="hidden md:contents text-neutral-50">{{ t('pages.faceSwap.step3Label') }}:</h3>
                                <h3>{{ t('pages.faceSwap.step3') }}</h3>
                            </div>
                        </div>
                    </div>

                    <div class="inline-flex flex-col justify-center items-start w-full h-52">
                        <h2 class="text-base font-medium leading-normal text-white md:text-xl md:my-6">
                            {{ t('pages.faceSwap.tipsTitle') }}
                        </h2>
                        <div
                            class="flex flex-col gap-y-3 self-stretch text-xs font-normal text-white opacity-50 md:text-base">
                            <span>{{ t('pages.faceSwap.tip1') }}</span>
                            <span>{{ t('pages.faceSwap.tip2') }}</span>
                            <span>{{ t('pages.faceSwap.tip3') }}</span>
                            <span>{{ t('pages.faceSwap.tip4') }}</span>
                        </div>
                    </div>
                </template>

            </div>
        </div>
        <NewFooter v-if="!isMobile" class="mt-20" />
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/pages';

/* .error-case img {
    width: 148px !important;
    margin-right: 20px;
} */
</style>
